type SmsSectionsInput = { message: string; header?: string; footer?: string };

/** 이전 자동 생성 문자의 알려진 인사말만 분리한다. 임의로 편집한 본문은 추측해 자르지 않는다. */
const legacyGreeting = /^안녕하세요 리프라이즈 입니다\. \d{1,2}월 한달간 고생 많으셨습니다! \n작업내역을 아래와 같이 정리하여 안내 드립니다\. \n입금은 오늘 처리될 예정입니다\.\n\n/;

export function smsSections(value: SmsSectionsInput) {
  let header = value.header ?? value.message.match(legacyGreeting)?.[0].slice(0, -2) ?? "";
  let footer = value.footer ?? "";
  let body = value.message;
  if (header && body.startsWith(`${header}\n\n`)) body = body.slice(header.length + 2);
  else header = "";
  if (footer && body.endsWith(`\n\n${footer}`)) body = body.slice(0, -footer.length - 2);
  else footer = "";
  return { header, body, footer };
}

export const composeSmsSections = ({ header, body, footer }: { header: string; body: string; footer: string }) =>
  `${header ? `${header}\n\n` : ""}${body}${footer ? `\n\n${footer}` : ""}`;

export function withSmsSections<T extends SmsSectionsInput>(value: T, patch: Partial<ReturnType<typeof smsSections>>) {
  const next = { ...smsSections(value), ...patch };
  return { ...value, message: composeSmsSections(next), header: next.header, footer: next.footer };
}
